import React from 'react';
import { observer } from 'mobx-react';
import "./style/PayPeriodSelection.css"


function dateDisplay(timesheet) {
    return (
        <span aria-label="Pay Period Week">
            {timesheet.weekEndDateObject.clone().subtract(6, "days").format("MMMM Do YYYY")} - {timesheet.weekEndDateObject.format("MMMM Do YYYY")}
        </span>
    )
}

function lateFlairDisplay(isLocked) {
    if (isLocked) {
        return (
            <span aria-label="Timesheet was late" className="badge badge-danger mr-2" style={{ textAlign: "center", padding: "0.5em 0.9em" }}>
                Late
            </span>
        )
    }
}

const PayPeriodSelection = (props) => {

    const account = props.store.accounts.getById(props.accountId);
    const type = props.type; //(Unsumbitted/Pending/Completed)

    const payPeriods = account.getPayPeriods();

    const accountStatus = account.getAccountStatus();


    //If the timesheet was already submitted
    const flexCss = {

    }

    let locked = false;
    if (accountStatus) {
        locked = accountStatus.status === "Locked";
    }

    if (payPeriods[type].length > 0) {
        const retval = payPeriods[type].map((timesheet, i) => {

            if (locked && !timesheet.isFinal) {
                const key = "payPeriodDisplay-random-" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
                return (
                    <div aria-label="listitem" aria-title={"Pay Period " + i} className="payPeriodSelect" key={key} style={flexCss}>
                        <div aria-label="Pay Period Description">
                            {lateFlairDisplay(timesheet.isLate)}
                            {dateDisplay(timesheet)}
                        </div>
                        <div>
                            <button className="btn btn-danger btn-slim" disabled>Account Locked</button>
                        </div>
                    </div>
                );
            }

            //If timesheet is already sumbitted

            if (timesheet.id) {
                const key = "payPeriodDisplay-" + timesheet.id;

                //If timesheet is certified (complete) 
                if (timesheet.isCertified) {
                    return (
                     <div role="listitem" aria-label={"Pay Period " + i} className="payPeriodSelect" key={key} style={flexCss}>
                            <div aria-label="Pay Period Description">
                                {lateFlairDisplay(timesheet.isLate)}
                                {dateDisplay(timesheet)}
                            </div>
                            <div>
                                <button aria-label="View timesheet" value={timesheet.weekEndDate} onClick={props.selectPayPeriod} className="btn btn-light btn-slim">View Timesheet</button>
                            </div>
                        </div>
                    );
                }
                //If timesheet is submitted after being saved
                else if (timesheet.isFinal) {
                    return (
                        <div role="listitem" aria-label={"Pay Period " + i} className="payPeriodSelect" key={key} style={flexCss}>
                            <div aria-label="Pay Period Description">
                                {lateFlairDisplay(timesheet.isLate)}
                                {dateDisplay(timesheet)}
                            </div>
                            <div>
                                <button aria-label="View timesheet" value={timesheet.weekEndDate} onClick={props.selectPayPeriod} className="btn btn-light btn-slim">View Timesheet</button>
                            </div>
                        </div>
                    )
                }
                //This is an unsubmitted timesheet, but it's been saved before. (Already has values )

                else {
                    //Most recent timesheet should have visual indicator.
                    if (timesheet.isMostRecent) {
                        return (
                            <div role="listitem" aria-label={"Pay Period " + i} className="payPeriodSelect" key={key} style={flexCss}>
                                <div aria-label="Pay Period Description"> 
                                    {lateFlairDisplay(timesheet.isLate)}
                                    {dateDisplay(timesheet)}
                                </div>
                                <div>
                                    <button aria-label="Delete timesheet draft" value={timesheet.id} onClick={props.deleteTimesheetDraft} className="btn btn-secondary btn-slim mr-3">Delete Draft</button>

                                    <button aria-label="Edit or save a timesheet draft" value={timesheet.weekEndDate} onClick={props.selectPayPeriod} className="btn btn-primary btn-slim">Edit/Save Draft</button>
                                </div>
                            </div>
                        );
                    }
                    else {
                        return (
                            <div role="listitem" aria-label={"Pay Period " + i} className="payPeriodSelect" key={key} style={flexCss}>
                                <div aria-label="Pay Period Description">
                                    {lateFlairDisplay(timesheet.isLate)}
                                    {dateDisplay(timesheet)}
                                </div>
                                <div>
                                    <button aria-label="Delete timesheet draft" value={timesheet.id} onClick={props.deleteTimesheetDraft} className="btn btn-secondary btn-slim mr-3">Delete Draft</button>
                                    <button aria-label="Edit a timesheet draft" value={timesheet.weekEndDate} onClick={props.selectPayPeriod} className="btn btn-secondary btn-slim">Edit Draft</button>
                                </div>
                            </div>
                        );
                    }
                }
            }

            else {
                const key = "payPeriodDisplay-random-" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
                //Completely new timesheet
                if (timesheet.isMostRecent) {
                    return (
                        <div role="listitem" aria-label={"Pay Period " + i} className="payPeriodSelect" key={key} style={flexCss}>
                            <div aria-label="Pay Period Description">
                                {lateFlairDisplay(timesheet.isLate)}
                                {dateDisplay(timesheet)}
                            </div>
                            <div>
                                <button aria-label="Create a timesheet draft" value={timesheet.weekEndDate} onClick={props.selectPayPeriod} className="btn btn-primary btn-slim">Create Draft</button>
                            </div>
                        </div>
                    )
                }
                else {
                    return (
                        <div role="listitem" aria-label={"Pay Period " + i} className="payPeriodSelect" key={key} style={flexCss}>
                            <div aria-label="Pay Period Description">
                                {lateFlairDisplay(timesheet.isLate)}
                                {dateDisplay(timesheet)}
                            </div>
                            <div>
                                <button aria-label="Create a timesheet draft"  value={timesheet.weekEndDate} onClick={props.selectPayPeriod} className="btn btn-secondary btn-slim">Create Draft</button>
                            </div>
                        </div>
                    )
                }
            }

        });

        return (
            <div>
                {retval}
            </div>
        );
    }
    //No matching timesheets of this type. 
    else {
        const key = "payPeriodDisplay-random-" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();

        return (
            <p key={key}>No timesheets to display.</p>
        )
    }

}


export default observer(PayPeriodSelection);